export default "__VITE_PUBLIC_ASSET__322c88f6__"